import $ from 'jquery'
import _ from 'lodash'
import UaParser from 'ua-parser-js'
import features from './features'

var deviceType = {
	_resetToDefaults: function() {
		this.edge = false
		this.chrome = false
		this.firefox = false
		this.safari = false

		this.touch = false
		this.touchOnly = false

		// True if the user agent is an IOS or Andriod device
		this.mobileIOSAndriod = false
		// True if the user agent is an IE touch device
		this.iPhone = false
		this.iPad = false
		this.iOS = false
		this.macOS = false

		this.majorVersion = null

		this.textSizeBug = null
	},

	gatherBrowserData: function(userAgentString) {
		this._resetToDefaults()
		var parser = new UaParser().setUA(userAgentString)
		var agent = parser.getResult()

		_.extend(this, window.browsers)
		$(() => delete window.browsers)

		let browsers = ['chrome', 'firefox', 'safari', 'edge']
		_.each(browsers, browser => {
			if (this[browser]) {
				$('html').addClass(browser)
			}
		})

		// We want to be able to detect if a touch interface is present which allows us
		// to handle inputs correctly. We also want to see if only a touch pointer is
		// available which will tell us not to use any hover events.
		//
		// It's easy to detect touch, but many touch devices like the MS Surface often
		// have mice attached. Additionally, even iOS and Android devices can have
		// bluetooth mice and keyboards attached. The strategy is to detect touch ability
		// and mark that device as touch capable. Then we try to detect devices which
		// probably won't have a mouse and mark it touch-only. Then we look for signs that
		// the browser does have a mouse pointer, either through CSS inspection or
		// mouse movements.

		if ('ontouchstart' in window ||			// html5 browsers
			navigator.maxTouchPoints > 0 ||		// future IE
			navigator.msMaxTouchPoints > 0 ||	// IE10
			agent.ua.indexOf('Touch') > -1		// MS Surface and Phone IE device
		) {
			this.touch = true
			$('html').addClass('touch')
		}

		// Apple touch device
		if (agent.os.name == 'iOS') {
			this.iOS = true
		}

		if (this.iOS ||
			navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 || /* iPad OS 13 */
		 	agent.os.name == 'Android') {
			this.mobileIOSAndriod = true // Apple or Android touch device
		}

		if (agent.os.name == 'Mac OS') {
			this.macOS = true
		}

		if (agent.ua.indexOf('Touch') > -1 ||	// MS Surface and Phone IE device
			navigator.maxTouchPoints > 0 ||		// future IE (another way to detect surface)
			navigator.msMaxTouchPoints > 0)	{	// IE10 (another way to detect surface)
			this.mobileIE
		}

		// If the user agent has been detected to be a mobile device (IOS/Android/IE)
		if (this.mobileIOSAndriod) {
			this.touchOnly = true
			$('html').addClass('touch-only')

			// This is a good test for IE systems (up to IE11) that don't support @media (hover)
			var isMouseMoving = function() {
				this.touchOnly = false
				$('html').removeClass('touch-only')
				$('body').off('mousemove', isMouseMoving)
			}

			// If the device is considered mobile but not IOS or Android, listen
			// for mousemoves. The touch-only class is removed in that case since
			// a connected mouse is assumed at that point.
			if (!this.mobileIOSAndriod) {
				$('body').on('mousemove', isMouseMoving)
			}

			var zIndex = $('#mouse-test').css('z-index')
			if (zIndex == 1) {
				// there's a style which sets the z index of this element
				// if there's a hover capable device available
				this.touchOnly = false
				$('html').removeClass('touch-only')
			}
		}

		if (this.safari && this.mobileIOSAndriod && agent.ua.indexOf('iPhone') >= 0) {
			this.iPhone = true
		}
		if (this.safari && this.mobileIOSAndriod && agent.ua.indexOf('iPad') >= 0) {
			this.iPad = true
		}

		this.majorVersion = agent.browser.major

		// #43586 #44270 detection for Chromium browsers that have a text size bug
		// on dashboards. See dashboards-overview.js for details
		this.textSizeBug = (deviceType.chrome || deviceType.edge) && parseInt(deviceType.majorVersion) < 97
	},

	isMobile: function() {
		return this.mobileIOSAndriod || this.mobileIE
	},

	isMobileSafari: function () {
		return this.safari && this.isMobile()
	}
}

if (features.browser) {
	deviceType.gatherBrowserData(navigator.userAgent)
}

export default deviceType

deviceType.__filename__ = 'components/device-type.js'
